import { getConnection } from '@/helpers/solana/getConnection';

const blockhashTtl = 500;
let lastUpdateBlockhash = 0;
let blockhash = '';
let lastValidBlockHeight: number = 0;
let blockhashPromise: Promise<void> | null = null;

export async function getLatestBlockhash() {
  if (lastUpdateBlockhash < Date.now() - blockhashTtl) {
    if (!blockhashPromise) {
      blockhashPromise = getConnection()
        .getLatestBlockhash({ commitment: 'max' })
        .then(async (res) => {
          blockhash = res.blockhash;
          lastValidBlockHeight = res.lastValidBlockHeight
        })
        .finally(() => {
          lastUpdateBlockhash = Date.now();
          blockhashPromise = null;
        });
    }
    await blockhashPromise;
    return blockhash;
  }
  return blockhash;
}

export async function getLatestBlockheight() {
  await getLatestBlockhash();
  return lastValidBlockHeight;
}
